import { css } from '@emotion/react';

export const styles = {
  option: css`
    white-space: break-spaces;
  `,
  clearBtnContainer: css`
    display: flex;
    justify-content: right;
  `,
  clearBtn: css`
    width: 100px;
  `
};
